var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page page-devices content"},[(!_vm.devicesLoaded)?_c('IconSpinner',{attrs:{"extra-classes":['page-devices__spinner']}}):_c('DeviceDetail',{attrs:{"device":_vm.device}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }